// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.institutionManager_container__5FedG {
  width: 100%;
  margin: 0;
  padding: 20px;
  font-family: "Arial", sans-serif;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  min-height: 100vh;
}

.institutionManager_navbar__TJ2f2 {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.institutionManager_navLinks__QYdBf {
  display: flex;
  gap: 20px;
}

.institutionManager_navLink__SqyfD {
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-weight: 500;
}
.institutionManager_navLink__SqyfD:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.institutionManager_header__5c3aI {
  text-align: center;
  margin-bottom: 30px;
  color: white;
}
.institutionManager_header__5c3aI h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
.institutionManager_header__5c3aI h2 {
  font-size: 1.8rem;
  margin: 0;
  opacity: 0.9;
}

.institutionManager_message__dOY\\+N {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.institutionManager_actions__\\+rvAi {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.institutionManager_actionButtons__imYm3 {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}
.institutionManager_actionButtons__imYm3 .institutionManager_button__QKHaK {
  padding: 12px 25px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_actionButtons__imYm3 .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.4);
}
.institutionManager_actionButtons__imYm3 .institutionManager_deleteButton__azVju {
  padding: 12px 25px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_actionButtons__imYm3 .institutionManager_deleteButton__azVju:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
}

.institutionManager_categoryManager__76hab {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_categoryManager__76hab h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.5rem;
}
.institutionManager_categoryManager__76hab h4 {
  margin: 20px 0 15px 0;
  color: #333;
  font-size: 1.2rem;
}

.institutionManager_addCategoryForm__MJ3PQ {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.institutionManager_addCategoryForm__MJ3PQ .institutionManager_input__fqOkx {
  flex: 1 1;
  min-width: 200px;
  padding: 12px 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}
.institutionManager_addCategoryForm__MJ3PQ .institutionManager_input__fqOkx:focus {
  outline: none;
  border-color: #1e3c72;
}
.institutionManager_addCategoryForm__MJ3PQ .institutionManager_button__QKHaK {
  padding: 12px 25px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_addCategoryForm__MJ3PQ .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.4);
}

.institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR {
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR span {
  flex: 1 1;
  font-weight: 500;
  color: #333;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_editInput__VsMwl {
  flex: 1 1;
  padding: 8px 12px;
  border: 2px solid #667eea;
  border-radius: 5px;
  font-size: 14px;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_editInput__VsMwl:focus {
  outline: none;
  border-color: #764ba2;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K, .institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju, .institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3, .institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K {
  background: #007bff;
  color: white;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K:hover {
  background: #0056b3;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju {
  background: #dc3545;
  color: white;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju:hover {
  background: #c82333;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3 {
  background: #28a745;
  color: white;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3:hover {
  background: #218838;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat {
  background: #6c757d;
  color: white;
}
.institutionManager_categoriesList__UuF8R .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat:hover {
  background: #5a6268;
}

.institutionManager_addSection__ad6tD {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.institutionManager_addInstitution__TKh6X {
  flex: 1 1;
  min-width: 400px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_addInstitution__TKh6X h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.5rem;
}

.institutionManager_addForm__JGy\\+p {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.institutionManager_addForm__JGy\\+p .institutionManager_input__fqOkx, .institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg {
  padding: 12px 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}
.institutionManager_addForm__JGy\\+p .institutionManager_input__fqOkx:focus, .institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg:focus {
  outline: none;
  border-color: #667eea;
}
.institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg {
  background: white;
  cursor: pointer;
}
.institutionManager_addForm__JGy\\+p .institutionManager_button__QKHaK {
  padding: 12px 25px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_addForm__JGy\\+p .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.institutionManager_bulkUpload__9H1cN {
  flex: 1 1;
  min-width: 400px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_bulkUpload__9H1cN h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.5rem;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_textarea__jNMc7 {
  width: 100%;
  padding: 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 15px;
  transition: border-color 0.3s ease;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_textarea__jNMc7:focus {
  outline: none;
  border-color: #667eea;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_select__rirKg {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  cursor: pointer;
  margin-bottom: 15px;
  transition: border-color 0.3s ease;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_select__rirKg:focus {
  outline: none;
  border-color: #667eea;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_button__QKHaK {
  width: 100%;
  padding: 12px 25px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_bulkUpload__9H1cN .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.institutionManager_institutionsList__PQWQg {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_institutionsList__PQWQg h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.5rem;
}

.institutionManager_loading__UZrL2, .institutionManager_empty__nO9eG {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 18px;
}

.institutionManager_tableContainer__w3Y3N {
  overflow-x: auto;
}

.institutionManager_table__Ptil6 {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.institutionManager_table__Ptil6 th, .institutionManager_table__Ptil6 td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e1e5e9;
}
.institutionManager_table__Ptil6 th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
}
.institutionManager_table__Ptil6 td {
  color: #333;
  font-size: 14px;
}
.institutionManager_table__Ptil6 tbody tr {
  transition: background-color 0.3s ease;
}
.institutionManager_table__Ptil6 tbody tr:hover {
  background-color: #f8f9fa;
}
.institutionManager_table__Ptil6 input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.institutionManager_editInput__VsMwl {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #667eea;
  border-radius: 5px;
  font-size: 14px;
}
.institutionManager_editInput__VsMwl:focus {
  outline: none;
  border-color: #764ba2;
}

.institutionManager_editSelect__pzbYO {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #667eea;
  border-radius: 5px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}
.institutionManager_editSelect__pzbYO:focus {
  outline: none;
  border-color: #764ba2;
}

.institutionManager_editActions__of48L {
  display: flex;
  gap: 8px;
}
.institutionManager_editActions__of48L .institutionManager_saveButton__L8Ax3 {
  padding: 6px 12px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.institutionManager_editActions__of48L .institutionManager_saveButton__L8Ax3:hover {
  background: #218838;
}
.institutionManager_editActions__of48L .institutionManager_cancelButton__mbuat {
  padding: 6px 12px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.institutionManager_editActions__of48L .institutionManager_cancelButton__mbuat:hover {
  background: #5a6268;
}

.institutionManager_actions__\\+rvAi {
  display: flex;
  gap: 8px;
}
.institutionManager_actions__\\+rvAi .institutionManager_editButton__MuX9K {
  padding: 6px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.institutionManager_actions__\\+rvAi .institutionManager_editButton__MuX9K:hover {
  background: #0056b3;
}
.institutionManager_actions__\\+rvAi .institutionManager_deleteButton__azVju {
  padding: 6px 12px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.institutionManager_actions__\\+rvAi .institutionManager_deleteButton__azVju:hover {
  background: #c82333;
}

.institutionManager_searchSection__I74Zz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 15px;
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ {
  position: relative;
  flex: 1 1;
  min-width: 300px;
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ .institutionManager_searchInput__uJbKw {
  width: 100%;
  padding: 12px 40px 12px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: white;
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ .institutionManager_searchInput__uJbKw:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ .institutionManager_searchInput__uJbKw::placeholder {
  color: #6c757d;
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ .institutionManager_clearSearchButton__rzFGH {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}
.institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ .institutionManager_clearSearchButton__rzFGH:hover {
  background: #c82333;
  transform: translateY(-50%) scale(1.1);
}
.institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  color: #495057;
}
.institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p label {
  font-weight: 600;
}
.institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p .institutionManager_itemsPerPageSelect__5Ogyh {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p .institutionManager_itemsPerPageSelect__5Ogyh:focus {
  outline: none;
  border-color: #667eea;
}
.institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p span {
  color: #6c757d;
}

.institutionManager_resultsInfo__wlQwp {
  background: rgba(255, 255, 255, 0.9);
  padding: 12px 20px;
  border-radius: 8px;
  margin-bottom: 15px;
  text-align: center;
  font-weight: 500;
  color: #495057;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.institutionManager_tableContainer__w3Y3N {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 th, .institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 td {
  padding: 15px 12px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 10;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 th.institutionManager_sortableHeader__9LI9- {
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-user-select: none;
          user-select: none;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 th.institutionManager_sortableHeader__9LI9-:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-1px);
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 th.institutionManager_sortableHeader__9LI9- .institutionManager_sortIndicator__2iVG5 {
  margin-left: 5px;
  font-weight: bold;
  font-size: 16px;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody tr {
  transition: all 0.3s ease;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody tr:hover {
  background: rgba(102, 126, 234, 0.05);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody tr:nth-child(even) {
  background: rgba(248, 249, 250, 0.5);
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody td {
  vertical-align: middle;
  color: #495057;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody td:first-child {
  width: 50px;
  text-align: center;
}
.institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 tbody td:last-child {
  width: 150px;
  text-align: center;
}

.institutionManager_pagination__7\\+YdY {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 15px;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationInfo__wubDn {
  font-weight: 500;
  color: #495057;
  font-size: 14px;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_paginationButton__1z94S {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  background: white;
  color: #495057;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 40px;
  text-align: center;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_paginationButton__1z94S:hover:not(:disabled) {
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_paginationButton__1z94S:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f8f9fa;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_paginationButton__1z94S.institutionManager_activePage__r7uce {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
  font-weight: 600;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_pageNumbers__UjyEa {
  display: flex;
  gap: 5px;
  align-items: center;
}
.institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS .institutionManager_pageNumbers__UjyEa .institutionManager_paginationButton__1z94S {
  min-width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.institutionManager_addSection__ad6tD {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_addSection__ad6tD .institutionManager_addInstitution__TKh6X h3, .institutionManager_addSection__ad6tD .institutionManager_bulkUpload__9H1cN h3 {
  color: #2c3e50;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  align-items: end;
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_input__fqOkx, .institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg {
  padding: 12px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_input__fqOkx:focus, .institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_input__fqOkx::placeholder, .institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_select__rirKg::placeholder {
  color: #6c757d;
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_button__QKHaK {
  padding: 12px 25px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_addSection__ad6tD .institutionManager_addForm__JGy\\+p .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);
}
.institutionManager_addSection__ad6tD .institutionManager_textarea__jNMc7 {
  width: 100%;
  padding: 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
  transition: all 0.3s ease;
}
.institutionManager_addSection__ad6tD .institutionManager_textarea__jNMc7:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.institutionManager_categoryManager__76hab {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.institutionManager_categoryManager__76hab h3 {
  color: #2c3e50;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}
.institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  align-items: end;
}
.institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ .institutionManager_input__fqOkx {
  flex: 1 1;
  min-width: 200px;
  padding: 12px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ .institutionManager_input__fqOkx:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ .institutionManager_button__QKHaK {
  padding: 12px 25px;
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ .institutionManager_button__QKHaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(23, 162, 184, 0.4);
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R h4 {
  color: #495057;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl {
  display: grid;
  gap: 10px;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR {
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #17a2b8;
  transition: all 0.3s ease;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR:hover {
  background: #e9ecef;
  transform: translateX(5px);
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_editInput__VsMwl {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_editInput__VsMwl:focus {
  outline: none;
  border-color: #667eea;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K, .institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3, .institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat, .institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju {
  padding: 8px 15px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: white;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_editButton__MuX9K:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3 {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_saveButton__L8Ax3:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_cancelButton__mbuat:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}
.institutionManager_categoryManager__76hab .institutionManager_categoriesList__UuF8R .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR .institutionManager_deleteButton__azVju:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

@media (max-width: 768px) {
  .institutionManager_searchSection__I74Zz {
    flex-direction: column;
    align-items: stretch;
  }
  .institutionManager_searchSection__I74Zz .institutionManager_searchBox__zJ4gQ {
    min-width: auto;
  }
  .institutionManager_searchSection__I74Zz .institutionManager_itemsPerPage__qug3p {
    justify-content: center;
  }
  .institutionManager_pagination__7\\+YdY {
    flex-direction: column;
    gap: 15px;
  }
  .institutionManager_pagination__7\\+YdY .institutionManager_paginationControls__CjKXS {
    justify-content: center;
  }
  .institutionManager_addForm__JGy\\+p {
    grid-template-columns: 1fr;
  }
  .institutionManager_categoryManager__76hab .institutionManager_addCategoryForm__MJ3PQ {
    flex-direction: column;
    align-items: stretch;
  }
  .institutionManager_categoryManager__76hab .institutionManager_categoriesTable__HECZl .institutionManager_categoryItem__4dndR {
    grid-template-columns: 1fr;
    gap: 10px;
    text-align: center;
  }
  .institutionManager_tableContainer__w3Y3N {
    overflow-x: auto;
  }
  .institutionManager_tableContainer__w3Y3N .institutionManager_table__Ptil6 {
    min-width: 600px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/institutionManager/institutionManager.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;EACA,6DAAA;EACA,iBAAA;AACF;;AAEA;EACE,oCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AACF;AACE;EACE,oCAAA;EACA,2BAAA;AACJ;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;AAAF;AAEE;EACE,iBAAA;EACA,mBAAA;EACA,2CAAA;AAAJ;AAGE;EACE,iBAAA;EACA,SAAA;EACA,YAAA;AADJ;;AAKA;EACE,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAFF;AAIE;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAFJ;AAII;EACE,2BAAA;EACA,6CAAA;AAFN;AAME;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAJJ;AAMI;EACE,2BAAA;EACA,+CAAA;AAJN;;AASA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AANF;AAQE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AANJ;AASE;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AARF;AAUE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AARJ;AAUI;EACE,aAAA;EACA,qBAAA;AARN;AAYE;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAVJ;AAYI;EACE,2BAAA;EACA,6CAAA;AAVN;;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,SAAA;EACA,gBAAA;EACA,WAAA;AAdN;AAiBI;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAfN;AAiBM;EACE,aAAA;EACA,qBAAA;AAfR;AAmBI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAjBN;AAoBI;EACE,mBAAA;EACA,YAAA;AAlBN;AAoBM;EACE,mBAAA;AAlBR;AAsBI;EACE,mBAAA;EACA,YAAA;AApBN;AAsBM;EACE,mBAAA;AApBR;AAwBI;EACE,mBAAA;EACA,YAAA;AAtBN;AAwBM;EACE,mBAAA;AAtBR;AA0BI;EACE,mBAAA;EACA,YAAA;AAxBN;AA0BM;EACE,mBAAA;AAxBR;;AA8BA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AA3BF;AA6BE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BF;AA8BE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA5BJ;AA8BI;EACE,aAAA;EACA,qBAAA;AA5BN;AAgCE;EACE,iBAAA;EACA,eAAA;AA9BJ;AAiCE;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA/BJ;AAiCI;EACE,2BAAA;EACA,+CAAA;AA/BN;;AAoCA;EACE,SAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AAjCF;AAmCE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,qBAAA;AAlCN;AAsCE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kCAAA;AApCJ;AAsCI;EACE,aAAA;EACA,qBAAA;AApCN;AAwCE;EACE,WAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAtCJ;AAwCI;EACE,2BAAA;EACA,+CAAA;AAtCN;;AA2CA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AAxCF;AA0CE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AAxCJ;;AA4CA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAzCF;;AA4CA;EACE,gBAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAzCF;AA2CE;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;AAzCJ;AA4CE;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA1CJ;AA6CE;EACE,WAAA;EACA,eAAA;AA3CJ;AA8CE;EACE,sCAAA;AA5CJ;AA8CI;EACE,yBAAA;AA5CN;AAgDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA9CJ;;AAkDA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA/CF;AAiDE;EACE,aAAA;EACA,qBAAA;AA/CJ;;AAmDA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAhDF;AAkDE;EACE,aAAA;EACA,qBAAA;AAhDJ;;AAoDA;EACE,aAAA;EACA,QAAA;AAjDF;AAmDE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAjDJ;AAmDI;EACE,mBAAA;AAjDN;AAqDE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAnDJ;AAqDI;EACE,mBAAA;AAnDN;;AAwDA;EACE,aAAA;EACA,QAAA;AArDF;AAuDE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AArDJ;AAuDI;EACE,mBAAA;AArDN;AAyDE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAvDJ;AAyDI;EACE,mBAAA;AAvDN;;AA6DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,SAAA;AA1DF;AA4DE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AA1DJ;AA4DI;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AA1DN;AA4DM;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AA1DR;AA6DM;EACE,cAAA;AA3DR;AA+DI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA7DN;AA+DM;EACE,mBAAA;EACA,sCAAA;AA7DR;AAkEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AAhEJ;AAkEI;EACE,gBAAA;AAhEN;AAmEI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAjEN;AAmEM;EACE,aAAA;EACA,qBAAA;AAjER;AAqEI;EACE,cAAA;AAnEN;;AAwEA;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,wCAAA;AArEF;;AAyEA;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;AAtEF;AAwEE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAtEJ;AAwEI;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AAtEN;AAyEI;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAvEN;AAyEM;EACE,eAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;AAvER;AAyEQ;EACE,6DAAA;EACA,2BAAA;AAvEV;AA0EQ;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AAxEV;AA8EM;EACE,yBAAA;AA5ER;AA8EQ;EACE,qCAAA;EACA,2BAAA;EACA,wCAAA;AA5EV;AA+EQ;EACE,oCAAA;AA7EV;AAiFM;EACE,sBAAA;EACA,cAAA;AA/ER;AAiFQ;EACE,WAAA;EACA,kBAAA;AA/EV;AAkFQ;EACE,YAAA;EACA,kBAAA;AAhFV;;AAwFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,eAAA;EACA,SAAA;AArFF;AAuFE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AArFJ;AAwFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAtFJ;AAwFI;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAtFN;AAwFM;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,8CAAA;AAtFR;AAyFM;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AAvFR;AA0FM;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAxFR;AA4FI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA1FN;AA4FM;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1FR;;AAiGA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AA9FF;AAiGI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA/FN;AAmGE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAjGJ;AAmGI;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAjGN;AAmGM;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAjGR;AAoGM;EACE,cAAA;AAlGR;AAsGI;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AApGN;AAsGM;EACE,2BAAA;EACA,6CAAA;AApGR;AAyGE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAvGJ;AAyGI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAvGN;;AA6GA;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AA1GF;AA4GE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA1GJ;AA6GE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA3GJ;AA6GI;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA3GN;AA6GM;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AA3GR;AA+GI;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA7GN;AA+GM;EACE,2BAAA;EACA,8CAAA;AA7GR;AAmHI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjHN;AAoHI;EACE,aAAA;EACA,SAAA;AAlHN;AAoHM;EACE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;AAlHR;AAoHQ;EACE,mBAAA;EACA,0BAAA;AAlHV;AAqHQ;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAnHV;AAqHU;EACE,aAAA;EACA,qBAAA;AAnHZ;AAuHQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AArHV;AAwHQ;EACE,6DAAA;EACA,YAAA;AAtHV;AAwHU;EACE,2BAAA;EACA,4CAAA;AAtHZ;AA0HQ;EACE,6DAAA;EACA,YAAA;AAxHV;AA0HU;EACE,2BAAA;EACA,4CAAA;AAxHZ;AA4HQ;EACE,6DAAA;EACA,YAAA;AA1HV;AA4HU;EACE,2BAAA;EACA,8CAAA;AA1HZ;AA8HQ;EACE,6DAAA;EACA,YAAA;AA5HV;AA8HU;EACE,2BAAA;EACA,4CAAA;AA5HZ;;AAqIA;EACE;IACE,sBAAA;IACA,oBAAA;EAlIF;EAoIE;IACE,eAAA;EAlIJ;EAqIE;IACE,uBAAA;EAnIJ;EAuIA;IACE,sBAAA;IACA,SAAA;EArIF;EAuIE;IACE,uBAAA;EArIJ;EAyIA;IACE,0BAAA;EAvIF;EA2IE;IACE,sBAAA;IACA,oBAAA;EAzIJ;EA6II;IACE,0BAAA;IACA,SAAA;IACA,kBAAA;EA3IN;EAgJA;IACE,gBAAA;EA9IF;EAgJE;IACE,gBAAA;EA9IJ;AACF","sourcesContent":[".container {\n  width: 100%;\n  margin: 0;\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  min-height: 100vh;\n}\n\n.navbar {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 10px;\n  padding: 15px 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.navLinks {\n  display: flex;\n  gap: 20px;\n}\n\n.navLink {\n  color: white;\n  text-decoration: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n  font-weight: 500;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateY(-2px);\n  }\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 30px;\n  color: white;\n\n  h1 {\n    font-size: 2.5rem;\n    margin-bottom: 10px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  }\n\n  h2 {\n    font-size: 1.8rem;\n    margin: 0;\n    opacity: 0.9;\n  }\n}\n\n.message {\n  background: rgba(255, 255, 255, 0.9);\n  color: #333;\n  padding: 15px 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.actions {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.actionButtons {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n\n  .button {\n    padding: 12px 25px;\n    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(30, 60, 114, 0.4);\n    }\n  }\n\n  .deleteButton {\n    padding: 12px 25px;\n    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);\n    }\n  }\n}\n\n.categoryManager {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 1.5rem;\n  }\n\n  h4 {\n    margin: 20px 0 15px 0;\n    color: #333;\n    font-size: 1.2rem;\n  }\n}\n\n.addCategoryForm {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n\n  .input {\n    flex: 1;\n    min-width: 200px;\n    padding: 12px 15px;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #1e3c72;\n    }\n  }\n\n  .button {\n    padding: 12px 25px;\n    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(30, 60, 114, 0.4);\n    }\n  }\n}\n\n.categoriesList {\n  .categoriesTable {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .categoryItem {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e1e5e9;\n\n    span {\n      flex: 1;\n      font-weight: 500;\n      color: #333;\n    }\n\n    .editInput {\n      flex: 1;\n      padding: 8px 12px;\n      border: 2px solid #667eea;\n      border-radius: 5px;\n      font-size: 14px;\n\n      &:focus {\n        outline: none;\n        border-color: #764ba2;\n      }\n    }\n\n    .editButton, .deleteButton, .saveButton, .cancelButton {\n      padding: 6px 12px;\n      border: none;\n      border-radius: 4px;\n      font-size: 12px;\n      cursor: pointer;\n      transition: background-color 0.3s ease;\n    }\n\n    .editButton {\n      background: #007bff;\n      color: white;\n\n      &:hover {\n        background: #0056b3;\n      }\n    }\n\n    .deleteButton {\n      background: #dc3545;\n      color: white;\n\n      &:hover {\n        background: #c82333;\n      }\n    }\n\n    .saveButton {\n      background: #28a745;\n      color: white;\n\n      &:hover {\n        background: #218838;\n      }\n    }\n\n    .cancelButton {\n      background: #6c757d;\n      color: white;\n\n      &:hover {\n        background: #5a6268;\n      }\n    }\n  }\n}\n\n.addSection {\n  display: flex;\n  gap: 30px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.addInstitution {\n  flex: 1;\n  min-width: 400px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 1.5rem;\n  }\n}\n\n.addForm {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n\n  .input, .select {\n    padding: 12px 15px;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n    }\n  }\n\n  .select {\n    background: white;\n    cursor: pointer;\n  }\n\n  .button {\n    padding: 12px 25px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n    }\n  }\n}\n\n.bulkUpload {\n  flex: 1;\n  min-width: 400px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 1.5rem;\n  }\n\n  .textarea {\n    width: 100%;\n    padding: 15px;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 16px;\n    font-family: inherit;\n    resize: vertical;\n    margin-bottom: 15px;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n    }\n  }\n\n  .select {\n    width: 100%;\n    padding: 12px 15px;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 16px;\n    background: white;\n    cursor: pointer;\n    margin-bottom: 15px;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n    }\n  }\n\n  .button {\n    width: 100%;\n    padding: 12px 25px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n    }\n  }\n}\n\n.institutionsList {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 1.5rem;\n  }\n}\n\n.loading, .empty {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 18px;\n}\n\n.tableContainer {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\n  th, td {\n    padding: 15px;\n    text-align: left;\n    border-bottom: 1px solid #e1e5e9;\n  }\n\n  th {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  td {\n    color: #333;\n    font-size: 14px;\n  }\n\n  tbody tr {\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n  }\n\n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n  }\n}\n\n.editInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #667eea;\n  border-radius: 5px;\n  font-size: 14px;\n\n  &:focus {\n    outline: none;\n    border-color: #764ba2;\n  }\n}\n\n.editSelect {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #667eea;\n  border-radius: 5px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n    border-color: #764ba2;\n  }\n}\n\n.editActions {\n  display: flex;\n  gap: 8px;\n\n  .saveButton {\n    padding: 6px 12px;\n    background: #28a745;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background: #218838;\n    }\n  }\n\n  .cancelButton {\n    padding: 6px 12px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background: #5a6268;\n    }\n  }\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n\n  .editButton {\n    padding: 6px 12px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background: #0056b3;\n    }\n  }\n\n  .deleteButton {\n    padding: 6px 12px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background: #c82333;\n    }\n  }\n}\n\n// Enhanced Search and Filter Styles\n.searchSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  flex-wrap: wrap;\n  gap: 15px;\n\n  .searchBox {\n    position: relative;\n    flex: 1;\n    min-width: 300px;\n\n    .searchInput {\n      width: 100%;\n      padding: 12px 40px 12px 15px;\n      border: 2px solid #e9ecef;\n      border-radius: 8px;\n      font-size: 16px;\n      transition: all 0.3s ease;\n      background: white;\n\n      &:focus {\n        outline: none;\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      }\n\n      &::placeholder {\n        color: #6c757d;\n      }\n    }\n\n    .clearSearchButton {\n      position: absolute;\n      right: 10px;\n      top: 50%;\n      transform: translateY(-50%);\n      background: #dc3545;\n      color: white;\n      border: none;\n      border-radius: 50%;\n      width: 24px;\n      height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      font-size: 12px;\n      transition: all 0.3s ease;\n\n      &:hover {\n        background: #c82333;\n        transform: translateY(-50%) scale(1.1);\n      }\n    }\n  }\n\n  .itemsPerPage {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-weight: 500;\n    color: #495057;\n\n    label {\n      font-weight: 600;\n    }\n\n    .itemsPerPageSelect {\n      padding: 8px 12px;\n      border: 2px solid #e9ecef;\n      border-radius: 6px;\n      background: white;\n      font-size: 14px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      &:focus {\n        outline: none;\n        border-color: #667eea;\n      }\n    }\n\n    span {\n      color: #6c757d;\n    }\n  }\n}\n\n.resultsInfo {\n  background: rgba(255, 255, 255, 0.9);\n  padding: 12px 20px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-weight: 500;\n  color: #495057;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);\n}\n\n// Enhanced Table Styles with Sorting\n.tableContainer {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n\n    th, td {\n      padding: 15px 12px;\n      text-align: left;\n      border-bottom: 1px solid #e9ecef;\n    }\n\n    th {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      font-weight: 600;\n      font-size: 14px;\n      position: sticky;\n      top: 0;\n      z-index: 10;\n\n      &.sortableHeader {\n        cursor: pointer;\n        transition: all 0.3s ease;\n        user-select: none;\n\n        &:hover {\n          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\n          transform: translateY(-1px);\n        }\n\n        .sortIndicator {\n          margin-left: 5px;\n          font-weight: bold;\n          font-size: 16px;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        transition: all 0.3s ease;\n\n        &:hover {\n          background: rgba(102, 126, 234, 0.05);\n          transform: translateY(-1px);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        }\n\n        &:nth-child(even) {\n          background: rgba(248, 249, 250, 0.5);\n        }\n      }\n\n      td {\n        vertical-align: middle;\n        color: #495057;\n\n        &:first-child {\n          width: 50px;\n          text-align: center;\n        }\n\n        &:last-child {\n          width: 150px;\n          text-align: center;\n        }\n      }\n    }\n  }\n}\n\n// Enhanced Pagination Styles\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  flex-wrap: wrap;\n  gap: 15px;\n\n  .paginationInfo {\n    font-weight: 500;\n    color: #495057;\n    font-size: 14px;\n  }\n\n  .paginationControls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n\n    .paginationButton {\n      padding: 8px 12px;\n      border: 2px solid #e9ecef;\n      background: white;\n      color: #495057;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      transition: all 0.3s ease;\n      min-width: 40px;\n      text-align: center;\n\n      &:hover:not(:disabled) {\n        border-color: #667eea;\n        color: #667eea;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background: #f8f9fa;\n      }\n\n      &.activePage {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        border-color: #667eea;\n        font-weight: 600;\n      }\n    }\n\n    .pageNumbers {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n\n      .paginationButton {\n        min-width: 35px;\n        height: 35px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n// Enhanced Form Styles\n.addSection {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 12px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  .addInstitution, .bulkUpload {\n    h3 {\n      color: #2c3e50;\n      font-size: 20px;\n      font-weight: bold;\n      margin-bottom: 20px;\n      padding-bottom: 10px;\n      border-bottom: 2px solid #e9ecef;\n    }\n  }\n\n  .addForm {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 15px;\n    align-items: end;\n\n    .input, .select {\n      padding: 12px 15px;\n      border: 2px solid #e9ecef;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: all 0.3s ease;\n      background: white;\n\n      &:focus {\n        outline: none;\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      }\n\n      &::placeholder {\n        color: #6c757d;\n      }\n    }\n\n    .button {\n      padding: 12px 25px;\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      color: white;\n      border: none;\n      border-radius: 8px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);\n      }\n    }\n  }\n\n  .textarea {\n    width: 100%;\n    padding: 15px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    font-size: 14px;\n    font-family: inherit;\n    resize: vertical;\n    min-height: 120px;\n    transition: all 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n    }\n  }\n}\n\n// Enhanced Category Manager Styles\n.categoryManager {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 12px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    color: #2c3e50;\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  .addCategoryForm {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 25px;\n    flex-wrap: wrap;\n    align-items: end;\n\n    .input {\n      flex: 1;\n      min-width: 200px;\n      padding: 12px 15px;\n      border: 2px solid #e9ecef;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: all 0.3s ease;\n\n      &:focus {\n        outline: none;\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      }\n    }\n\n    .button {\n      padding: 12px 25px;\n      background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n      color: white;\n      border: none;\n      border-radius: 8px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 15px rgba(23, 162, 184, 0.4);\n      }\n    }\n  }\n\n  .categoriesList {\n    h4 {\n      color: #495057;\n      font-size: 18px;\n      font-weight: 600;\n      margin-bottom: 15px;\n    }\n\n    .categoriesTable {\n      display: grid;\n      gap: 10px;\n\n      .categoryItem {\n        display: grid;\n        grid-template-columns: 1fr 1fr auto auto;\n        gap: 15px;\n        align-items: center;\n        padding: 15px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        border-left: 4px solid #17a2b8;\n        transition: all 0.3s ease;\n\n        &:hover {\n          background: #e9ecef;\n          transform: translateX(5px);\n        }\n\n        .editInput {\n          padding: 8px 12px;\n          border: 2px solid #e9ecef;\n          border-radius: 6px;\n          font-size: 14px;\n\n          &:focus {\n            outline: none;\n            border-color: #667eea;\n          }\n        }\n\n        .editButton, .saveButton, .cancelButton, .deleteButton {\n          padding: 8px 15px;\n          border: none;\n          border-radius: 6px;\n          font-size: 14px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.3s ease;\n        }\n\n        .editButton {\n          background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);\n          color: white;\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);\n          }\n        }\n\n        .saveButton {\n          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n          color: white;\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n          }\n        }\n\n        .cancelButton {\n          background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n          color: white;\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);\n          }\n        }\n\n        .deleteButton {\n          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n          color: white;\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n          }\n        }\n      }\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .searchSection {\n    flex-direction: column;\n    align-items: stretch;\n\n    .searchBox {\n      min-width: auto;\n    }\n\n    .itemsPerPage {\n      justify-content: center;\n    }\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 15px;\n\n    .paginationControls {\n      justify-content: center;\n    }\n  }\n\n  .addForm {\n    grid-template-columns: 1fr;\n  }\n\n  .categoryManager {\n    .addCategoryForm {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    .categoriesTable {\n      .categoryItem {\n        grid-template-columns: 1fr;\n        gap: 10px;\n        text-align: center;\n      }\n    }\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n\n    .table {\n      min-width: 600px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `institutionManager_container__5FedG`,
	"navbar": `institutionManager_navbar__TJ2f2`,
	"navLinks": `institutionManager_navLinks__QYdBf`,
	"navLink": `institutionManager_navLink__SqyfD`,
	"header": `institutionManager_header__5c3aI`,
	"message": `institutionManager_message__dOY+N`,
	"actions": `institutionManager_actions__+rvAi`,
	"actionButtons": `institutionManager_actionButtons__imYm3`,
	"button": `institutionManager_button__QKHaK`,
	"deleteButton": `institutionManager_deleteButton__azVju`,
	"categoryManager": `institutionManager_categoryManager__76hab`,
	"addCategoryForm": `institutionManager_addCategoryForm__MJ3PQ`,
	"input": `institutionManager_input__fqOkx`,
	"categoriesList": `institutionManager_categoriesList__UuF8R`,
	"categoriesTable": `institutionManager_categoriesTable__HECZl`,
	"categoryItem": `institutionManager_categoryItem__4dndR`,
	"editInput": `institutionManager_editInput__VsMwl`,
	"editButton": `institutionManager_editButton__MuX9K`,
	"saveButton": `institutionManager_saveButton__L8Ax3`,
	"cancelButton": `institutionManager_cancelButton__mbuat`,
	"addSection": `institutionManager_addSection__ad6tD`,
	"addInstitution": `institutionManager_addInstitution__TKh6X`,
	"addForm": `institutionManager_addForm__JGy+p`,
	"select": `institutionManager_select__rirKg`,
	"bulkUpload": `institutionManager_bulkUpload__9H1cN`,
	"textarea": `institutionManager_textarea__jNMc7`,
	"institutionsList": `institutionManager_institutionsList__PQWQg`,
	"loading": `institutionManager_loading__UZrL2`,
	"empty": `institutionManager_empty__nO9eG`,
	"tableContainer": `institutionManager_tableContainer__w3Y3N`,
	"table": `institutionManager_table__Ptil6`,
	"editSelect": `institutionManager_editSelect__pzbYO`,
	"editActions": `institutionManager_editActions__of48L`,
	"searchSection": `institutionManager_searchSection__I74Zz`,
	"searchBox": `institutionManager_searchBox__zJ4gQ`,
	"searchInput": `institutionManager_searchInput__uJbKw`,
	"clearSearchButton": `institutionManager_clearSearchButton__rzFGH`,
	"itemsPerPage": `institutionManager_itemsPerPage__qug3p`,
	"itemsPerPageSelect": `institutionManager_itemsPerPageSelect__5Ogyh`,
	"resultsInfo": `institutionManager_resultsInfo__wlQwp`,
	"sortableHeader": `institutionManager_sortableHeader__9LI9-`,
	"sortIndicator": `institutionManager_sortIndicator__2iVG5`,
	"pagination": `institutionManager_pagination__7+YdY`,
	"paginationInfo": `institutionManager_paginationInfo__wubDn`,
	"paginationControls": `institutionManager_paginationControls__CjKXS`,
	"paginationButton": `institutionManager_paginationButton__1z94S`,
	"activePage": `institutionManager_activePage__r7uce`,
	"pageNumbers": `institutionManager_pageNumbers__UjyEa`
};
export default ___CSS_LOADER_EXPORT___;
